import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';
import type {
  EmailVerificationResponse,
  EmailQuoteResponse
} from 'api/models/TEmail';
import type { RootState } from 'state/store';

export type EmailQuoteState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
  details: {
    firstName: string;
    lastName: string;
    email: string;
  };
  data: EmailVerificationResponse | EmailQuoteResponse | object;
};

export const initialState: EmailQuoteState = {
  isLoading: false,
  errors: null,
  details: {
    firstName: '',
    lastName: '',
    email: ''
  },
  data: {}
};

export const slice = createSlice({
  name: 'emailQuote',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    },
    setFormField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setFormField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectDetails = (state: RootState) => selectSlice(state).details;
export const selectIsLoading = (state: RootState) =>
  selectSlice(state).isLoading;
export const selectErrors = (state: RootState) => selectSlice(state).errors;
export const selectData = <
  T extends EmailQuoteState['data'] = EmailQuoteState['data']
>(
  state: RootState
) => selectSlice(state).data as T;

export default slice.reducer;
